import React, { useState, useContext, useEffect } from "react";
import { doc, deleteDoc, getDoc } from "firebase/firestore";
import { getAuth, signOut, deleteUser } from "firebase/auth";
import { auth, db } from "../authentication/firebase/firebase";
import ForumData from "../data/forum-data.json";
import Logo from "../images/academates-logo.png";
import "./home.scss";
import { IsAuthContext } from "../../App";
import ForumPage from "../forum-page/forum-page";

const Home = () => {
  // const [isAuthenticated, setIsAuthenticated, userData, setUserData] =
  //   useContext(IsAuthContext);
  const contextValues = useContext(IsAuthContext);
  const [, setIsAuthenticated, userData, setUserData] = contextValues;

  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(true);
  const [isSignOutOpen, setIsSignOutOpen] = useState(false);
  // const [isHovered, setIsHovered] = useState(false);

  const [forumAddress, setForumAddress] = useState(() => {
    const storedSubject = localStorage.getItem("forumAddress");
    return storedSubject || null;
  });

  const handleForumClick = (forum) => {
    setForumAddress(forum);
    localStorage.setItem("forumAddress", forum);
  };

  useEffect(() => {
    const getUserData = async () => {
      if (userData) {
        const userDocRef = doc(db, "users", userData);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setUsername(data.username);
          setEmail(data.email);
        } else {
          console.log("User document does not exist");
          handleSignOut();
        }
      } else {
        console.log("nothing");
      }
    };
    getUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      setUserData("");
      localStorage.removeItem("forumAddress");
    } catch (err) {
      console.error(err);
    }
    setIsAuthenticated(false);
  };

  const handleDeleteUser = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    const userDocRef = doc(db, "users", userData);

    if (user) {
      try {
        await deleteUser(user);
        await deleteDoc(userDocRef);
        setUserData("");
      } catch (error) {
        console.error("An error happened:", error);
      }
      setIsAuthenticated(false);
    }
  };

  const hideModals = () => {
    setIsAccountOpen(false);
    setIsDeleteOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1040) {
        setShowMenu(false);
      } else {
        setShowMenu(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="home">
      {showMenu && (
        <div className="menu">
          <header>
            <img src={Logo} alt="Logo" />
            <h1>Forums</h1>
          </header>

          <div className="forums-container">
            <ul>
              {ForumData.Forums.map((forum, index) => (
                <li
                  key={forum.forumAddress}
                  onClick={() => handleForumClick(forum.forumAddress)}
                >
                  {forum.forumAddress}
                </li>
              ))}
            </ul>
          </div>

          {isAccountOpen && (
            <div className="account-modal-container">
              <div className="account-modal">
                <div className="account-info">
                  <h2>Username: </h2>
                  <h2>{username}</h2>
                  <h2>Email: </h2>
                  <h2>{email}</h2>
                </div>
                <div className="account-buttons">
                  <button onClick={() => setIsDeleteOpen(!isDeleteOpen)}>
                    Delete Account
                  </button>
                  <button onClick={hideModals}>Cancel</button>
                </div>
              </div>
            </div>
          )}
          {isDeleteOpen && (
            <div className="delete-modal-container">
              <div className="delete-modal">
                <h2>Are you sure you want to delete your account?</h2>
                <div className="delete-modal-buttons">
                  <button onClick={handleDeleteUser}>YES</button>
                  <button onClick={() => setIsDeleteOpen(false)}>NO</button>
                </div>
              </div>
            </div>
          )}
          {isSignOutOpen && (
            <div className="sign-out-modal-container">
              <div className="sign-out-modal">
                <h2>Are you sure you want to sign out?</h2>
                <div className="sign-out-modal-buttons">
                  <button onClick={handleSignOut}>Yes</button>
                  <button onClick={() => setIsSignOutOpen(false)}>No</button>
                </div>
              </div>
            </div>
          )}
          <div className="other-container">
            <h1>Other</h1>
            <div className="other-container-background">
              <ul>
                <li onClick={() => setIsAccountOpen(!isAccountOpen)}>
                  Account 👤
                </li>
                <a href="mailto: infoacademates@gmail.com">Contact 📨</a>
                <li onClick={() => setIsSignOutOpen(!isSignOutOpen)}>
                  Sign Out 🔒
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      <button
        onClick={() => setShowMenu(!showMenu)}
        className="toggle-container"
        // onMouseEnter={() => setIsHovered(true)}
        // onMouseLeave={() => setIsHovered(false)}
        style={{ rotate: showMenu ? "0deg" : "180deg" }}
      >
        <i class="fa-solid fa-angle-right"></i>
      </button>

      <ForumPage
        forumAddress={forumAddress}
        username={username}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
      />
    </div>
  );
};

export default Home;
